<template>
  <v-container
    fluid
    id="guide-tips"
    class="mt-3 pa-0 pr-md-0 pr-3 pl-3"
    fill-height
  >
    <v-row align-start wrap fill-height>
      <v-col cols="12" class="pa-0">
        <ArticleHighlight :class="'round-top'" :highlight="highlight" />
      </v-col>
      <v-col
        cols="12"
        v-for="(tip, index) in items"
        :key="index"
        class="guide-tip-item pa-0"
        xs12
      >
        <GuideTip :item="tip" :class="{ 'border-m': (index + 1) % 2 == 0 }" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GuideTip from '@/components/Articles/GuideTip.vue'
import ArticleHighlight from '@/components/Articles/ArticleHighlight'

export default {
  components: {
    GuideTip,
    ArticleHighlight,
  },
  data() {
    return {}
  },
  props: {
    items: {
      type: Array,
      required: false,
    },
    highlight: {
      type: String,
      required: false,
      default: '',
    },
  },
}
</script>

<style scoped>
#guide-tips {
  height: 515px;
  max-height: 515px;
}

.guide-tip-item {
  background-color: #f6f7f9;
}
</style>
